/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import env from 'env'
import { getURLSearchParams } from 'redux-app/utils/api'

export const login = ({ username, password, googleRecaptchaResponse, authToken }) => ({
  type: 'AUTH/LOGIN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/auth/token',
      data: {
        username,
        password,
        googleRecaptchaResponse,
        authToken,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
login.toString = () => 'AUTH/LOGIN'

export const logout = ({ authToken, refreshToken }) => ({
  type: 'AUTH/LOGOUT',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/auth/logout',
      data: {
        authToken,
        refreshToken,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
logout.toString = () => 'AUTH/LOGOUT'

export const refresh = ({ refresh_token }) => ({
  type: 'AUTH/REFRESH_TOKEN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/auth/token',
      data: {
        refreshToken: refresh_token,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
refresh.toString = () => 'AUTH/REFRESH_TOKEN'

export const signUp = ({
  email,
  password,
  googleRecaptchaResponse,
  subscriptionPlanId,
}) => ({
  type: 'AUTH/SIGN_UP',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts',
      data: {
        email,
        password,
        googleRecaptchaResponse,
        subscriptionPlanId,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
signUp.toString = () => 'AUTH/SIGN_UP'

export const forgotPassword = ({ email, googleRecaptchaResponse }) => ({
  type: 'AUTH/FORGOT_PASSWORD',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/password/reset',
      data: {
        email,
        googleRecaptchaResponse,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
forgotPassword.toString = () => 'AUTH/FORGOT_PASSWORD'

export const resendForgotPassword = token => ({
  type: 'AUTH/RESEND_FORGOT_PASSWORD',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/password/reset/resend',
      data: {
        token,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
resendForgotPassword.toString = () => 'AUTH/RESEND_FORGOT_PASSWORD'

export const resetPassword = ({
  password,
  token,
}) => ({
  type: 'AUTH/RESET_PASSWORD',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/password/update',
      data: {
        password,
        token,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
resetPassword.toString = () => 'AUTH/RESET_PASSWORD'

export const confirmEmail = ({ token }) => ({
  type: 'AUTH/CONFIRM_EMAIL',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/registration/confirm',
      data: {
        token,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
confirmEmail.toString = () => 'AUTH/CONFIRM_EMAIL'

export const resendEmail = ({ token }) => ({
  type: 'AUTH/RESEND_EMAIL',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/registration/resend',
      data: {
        token,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
resendEmail.toString = () => 'AUTH/RESEND_EMAIL'

export const setPassword = ({ password, confirmPassword, code, isAcceptedTermsOfService }) => ({
  type: 'AUTH/SET_PASSWORD',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/account/set-password',
      data: {
        code,
        password,
        confirmPassword,
        isAcceptedTermsOfService,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
setPassword.toString = () => 'AUTH/SET_PASSWORD'

export const checkChangePasswordLink = ({ code }) => ({
  type: 'AUTH/CHECK_CHANGE_PASSWORD_LINK',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/account/confirmation-link-token/validation?${getURLSearchParams({ code })}`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {
    noAuth: true,
  },
})
checkChangePasswordLink.toString = () => 'AUTH/CHECK_CHANGE_PASSWORD_LINK'

export const completeInitialSubscription = ({
  userId,
  billingAddress,
  company,
  shippingAddress,
  creditCard,
}) => ({
  type: 'AUTH/COMPLETE_SUBSCRIPTIONS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/subscriptions/initial',
      data: {
        userId,
        billingAddress,
        company,
        shippingAddress,
        creditCard,
      },
      headers: {},
      method: 'PUT',
    },
  },
  meta: {
    noAuth: true,
  },
})
completeInitialSubscription.toString = () => 'AUTH/COMPLETE_SUBSCRIPTIONS'

export const confirmChangeEmail = ({ token }) => ({
  type: 'AUTH/CONFIRM_CHANGE_EMAIL',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/email/confirm',
      data: {
        token,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
confirmChangeEmail.toString = () => 'AUTH/CONFIRM_CHANGE_EMAIL'

export const leaveEmail = (planId, { name, email, captcha: googleRecaptchaResponse }) => ({
  type: 'AUTH/LEAVE_EMAIL',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/${planId}/wait-list`,
      data: {
        name,
        email,
        googleRecaptchaResponse,
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
leaveEmail.toString = () => 'AUTH/LEAVE_EMAIL'

export const addMeToWaitlist = planId => ({
  type: 'AUTH/ADD_ME_TO_WAITLIST',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/${planId}/wait-list/me`,
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
addMeToWaitlist.toString = () => 'AUTH/ADD_ME_TO_WAITLIST'
